import { SumInsuredType } from 'scenes/common/types';

import {
  WireBuildingCoverSI,
  WireBuildingCoverSIOption,
  WireMortgageLender,
  WireSecurity,
} from '../types';

export const wireBuildingCoverSIOption: {
  [key in SumInsuredType]: WireBuildingCoverSIOption;
} = {
  [SumInsuredType.Estimated]: WireBuildingCoverSIOption.Estimated,
  [SumInsuredType.Agreed]: WireBuildingCoverSIOption.Manual,
  [SumInsuredType.Unspecified]: WireBuildingCoverSIOption.Unspecified,
  [SumInsuredType.Entered]: WireBuildingCoverSIOption.Manual,
};

export const toWireSecurities = (securityFeatures: string[]): WireSecurity[] =>
  securityFeatures.map((security) => ({
    code: security,
  }));

export const defaultBuldingTypeDetails = {
  isAboveGround: false,
  isMultiStory: false,
  isUnderStrata: false,
  level: '',
};

export const defaultHomeBuldingTypeDetails = {
  isMultiStory: false,
  isUnderStrata: false,
  level: '',
};

export const defaultBuildingCoverSI = {
  selected: WireBuildingCoverSIOption.Estimated,
  estimated: 0,
};

export const mapBuildingDetails = (
  isMultiStorey: boolean,
  isUnderStrata: boolean,
  level: string = '',
  isHome?: boolean
) => {
  const defaultValues = isHome
    ? defaultHomeBuldingTypeDetails
    : defaultBuldingTypeDetails;

  return {
    ...defaultValues,
    isMultiStory: isMultiStorey,
    isUnderStrata,
    level,
  };
};

export const mapFreestanding = (
  isAboveGround: boolean,
  isMultiStorey: boolean
) => ({
  ...defaultBuldingTypeDetails,
  isAboveGround,
  isMultiStory: isMultiStorey,
});

export const toWireMortgageLender = (
  mortgageLender: string,
  mortgageProviderOther: string
): WireMortgageLender => ({
  popular: mortgageLender,
  ...(mortgageLender === 'Other' && {
    other: mortgageProviderOther,
  }),
});

export const mapBuildingCoverSI = (
  sumInsuredType: SumInsuredType,
  sumInsuredAmount: string
): WireBuildingCoverSI => ({
  selected: wireBuildingCoverSIOption[sumInsuredType],
  estimated: Number(sumInsuredAmount),
});
